const ButtonTypes = {
  WHITE: 'white',
  PRIMARY: 'primary',
  LIGHT: 'light',
  SECONDARY: 'secondary',
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  DANGER: 'danger',
  DARK: 'dark',
  LIGHT_PRIMARY: 'lightPrimary',
  LIGHT_SUCCESS: 'lightSuccess',
  LIGHT_INFO: 'lightInfo',
  LIGHT_WARNING: 'lightWarning',
  LIGHT_DANGER: 'lightDanger',
  LIGHT_DARK: 'lightDark',
  ACTIVE_LIGHT: 'activeLight',
};
export default ButtonTypes;
